import { render, staticRenderFns } from "./ButtonEditPurchaseBuyer.vue?vue&type=template&id=772e9397&"
import script from "./ButtonEditPurchaseBuyer.vue?vue&type=script&lang=ts&"
export * from "./ButtonEditPurchaseBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports